import type { Object3D } from 'three';

const PREVIEW_MARKER_KEY = '__puppyCadSketchEntityReferencePreview';

/**
 * 标记对象为草图实体引用预览对象。
 *
 * @param object 需要写入预览标记的对象。
 */
export function markSketchEntityReferencePreview(object: Object3D): void {
	Reflect.set(object, PREVIEW_MARKER_KEY, true);
}

/**
 * 清理对象上的草图实体引用预览标记。
 *
 * @param object 需要移除预览标记的对象。
 */
export function clearSketchEntityReferencePreview(object: Object3D): void {
	Reflect.deleteProperty(object, PREVIEW_MARKER_KEY);
}

/**
 * 判断对象是否已被标记为草图实体引用预览对象。
 *
 * @param object 需要判断的对象。
 * @returns 若对象已被标记则返回 true。
 */
export function isSketchEntityReferencePreview(object: Object3D): boolean {
	return Reflect.get(object, PREVIEW_MARKER_KEY) === true;
}
